module.exports = __webpack_public_path__ + "static/conduits-flow-7c5f50109c061ba2961398880ba4d638.svg";